export const Tape = ({ items, className = "", reverse = false, testid = "tape" }) => {
  const row = [...items, ...items, ...items];
  return (
    <div data-testid={testid} className={`overflow-hidden border-y-4 border-kadak py-3 ${className}`}>
      <div className={`flex w-max whitespace-nowrap ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {row.map((t, i) => (
              <span key={`${dup}-${i}`} className="mx-5 flex items-center gap-5 font-bungee text-base sm:text-lg tracking-widest">
                {t} <span className="inline-block h-2.5 w-2.5 rounded-full bg-current opacity-70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
